import * as React from 'react';
import '@fiverr/i18n/singleton';
import * as socket from './webSocket';
import Container from './components/Container';
import './index.scss';

export interface RealtimeNotificationsProps {
    [key: string]: any;
}

const RealtimeNotifications: React.FC<RealtimeNotificationsProps> = (props) =>
    React.createElement(Container, { ...props, socket });

export default RealtimeNotifications;
